import HttpService from "@core/services/http/http.service";
import { RequestParams, Signal } from "@core/services/http/http.type";
import { GetListResponse } from "@app/types";
import { ActionLog } from "@app/types/log.type";

class _LogService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<ActionLog>>("/admin/api/v3/important-action-logs", {
      queryParams: { ...requestParams },
      signal,
    });
  }

  public restore(id: number) {
    return HttpService.post(`/admin/api/v3/important-action-logs/${id}/restore`);
  }
}

const LogService = new _LogService();

export default LogService;
